// pdf.js worker wiring, in its own module for ONE reason: `import.meta.url`
// is a syntax error once babel-jest lowers modules to CJS, so this file must
// be swappable in tests. package.json's jest.moduleNameMapper maps
// "configurePdfWorker" to a no-op stub in src/__mocks__ — keep this module
// free of anything tests would want, and keep its name unique.
//
// The `new URL(..., import.meta.url)` pattern is webpack 5's asset syntax:
// CRA copies the worker bundle into the build output and the URL points at
// it, so the worker is same-origin and version-locked to the installed
// pdfjs-dist (react-pdf 10.x ships pdfjs-dist 5.x, whose worker is the
// .min.mjs build).
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url,
).toString();
